import { render, staticRenderFns } from "./LandlordKYC.vue?vue&type=template&id=3706ae96&"
import script from "./LandlordKYC.vue?vue&type=script&lang=js&"
export * from "./LandlordKYC.vue?vue&type=script&lang=js&"
import style0 from "./LandlordKYC.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports